<footer class="footer">
    <div class="modal-footer">

        <div class="col-md-12"> <a class="navbar-brand footer-logo-box" href="#"><img src="assets/img/logo.png"
                    class="img-responsive" alt="Logo"></a> © 2025 TankhaPay. Akal Information Systems Ltd. All Rights
            Reserved.
        </div>
    </div>
</footer>